import React from 'react';
import cx from 'classnames';
import styles from './routering.section.module.css';
import { getTranslation } from '../locales/i18n';

export const RouteringCard: React.FC<React.PropsWithChildren<{ digidNaam: string; status: string; periodeVan: Date; periodeTot: Date }>> = ({
  digidNaam,
  status,
  periodeVan,
  periodeTot,
  children,
}) => {
  return (
    <div>
      <div className="vl-info-tile">
        <div className="vl-info-tile__header__wrapper">
          <p className={cx('vl-info-tile__header__title', styles.title, styles[status.toLowerCase()])} data-cy={'title-' + digidNaam}>
            {digidNaam}
          </p>
          <div className={cx('vl-info-tile__header__subtitle', 'vl-u-spacer', styles.subtitle)}>
            {getTranslation('routering.section.title', { digidName: digidNaam, from: periodeVan, to: periodeTot })}
          </div>
          {children}
        </div>
      </div>
      <br />
    </div>
  );
};
